// const FARABOURSE_LICENSE_GUID = '35b7883c-a827-484f-8918-65a504a547ff'

const appDetails = {
  title: 'زیما',
  description: 'سامانه ی تامین مالی جمعی زیما',
  url: 'https://zeema.fund',
  twitterUserName: '@zeema',
  category: 'crowdfunding',
  ogImageURL: '/og.png',
  enamadCode: 'i2DdDNQ1e6n30LxxkCcw',
  enamadURL: 'https://trustseal.enamad.ir/?id=270506&Code=i2DdDNQ1e6n30LxxkCcw',
  enamadImageURL: '/images/footer/enamad.png',
  faraboorsCode: 'rgvlgwmdxlaphwlabrgw',
  // faraboorsURL: `https://cf.ifb.ir/report/PlatformActivityLicenseTrustSealDetail?licenseguid=${FARABOURSE_LICENSE_GUID}`,
  faraboorsURL: 'https://www.ifb.ir/Finstars/AllCrowdFundingAgents.aspx',
  faraboorsImageURL: '/images/footer/farabourse.svg',
  sejamURL: 'https://profilesejam.csdiran.ir/session',
  sejamChoosePlanURL: 'https://profilesejam.csdiran.ir',
  faraboorsPublicLink: 'https://www.ifb.ir/Finstars/AllCrowdFundingAgents.aspx',
  saderatPublicLink: 'https://saderatbourse.ir/',
  supportPhone: '02192008828',
  supportPhoneLabel: '02192008828',
  supportPhoneLabel2: '09926534279',
  supportPhoneLabelRTL: '02192008828',
  instagramURL:
    'https://www.instagram.com/zeema.fund?igsh=MW9xNzJydW51aDFvOQ==',
  linkedInURL: 'https://www.linkedin.com/company/zeemafund/',
  telegramURL: 'https://t.me/zeemacrowd',
  baleURL: 'https://ble.ir/Zeemacrowd',
  emailURL: 'Info@zeema.fund',
}

export { appDetails }
